import { until } from 'until-async'
import { loadScript } from '../../robowhale/net/load-script'
import { getErrorLog } from '../../robowhale/utils/error/utils'
import { Platform } from '../Platform'

export abstract class BasePlatformPreloader {
	constructor() {}

	abstract readonly type: Platform

	abstract loadAndInit(): Promise<unknown>

	protected async loadScriptWithRetries(url: string, maxAttempts = 3, attempt = 1): Promise<void> {
		console.log(`platform script load#${attempt} - start (${url})`)

		const [error] = await until(() => loadScript(url))
		if (!error) {
			console.log(`platform script load#${attempt} - complete`)
			return
		}

		console.warn(`platform script load#${attempt} - failed (${getErrorLog(error)})`)

		const isLastAttempt = attempt === maxAttempts
		if (isLastAttempt) {
			throw error instanceof Error ? error : new Error('script failed to load')
		}

		return this.loadScriptWithRetries(url, maxAttempts, attempt + 1)
	}

	protected stringifyValue(value: unknown): string {
		if (typeof value === 'string') {
			return value
		}

		try {
			return JSON.stringify(value)
		} catch (e) {
			return 'error'
		}
	}
}
